module.exports = __webpack_public_path__ + "img/time_line_circular_connect_head_order.2530cd76.svg";